<template>
  <div class="ViewPromo" ref="container">
    <view-top :title="title" :desc="desc" :id="id"></view-top>
    <view-how-cards class="ViewPromo__section"></view-how-cards>
    <view-promo-products
      :id="id"
      :productId="productId"
      class="ViewPromo__section"
    ></view-promo-products>

    <div class="ViewDieselInfo ViewPromo__section">
      <div class="ViewDieselInfo__row">
        <div class="ViewDieselInfo__col">
          <div class="ViewDieselInfo__content">
            <h2 class="ViewDieselInfo__title">{{ name }}</h2>
            <div class="ViewDieselInfo__inn">ИНН {{ inn }}</div>
            <div class="ViewDieselInfo__text app-typography">
              <h4>
                ООО «Татнефть – АЗС Центр» осуществляет продажу нефтепродуктов
                мелким оптом
              </h4>
              <p>
                Реализация нефтепродуктов в регионах осуществляется через
                дочерние предприятие ПАО «Татнефть», по Москве и МО от ООО
                «Татнефть-АЗС-Запад».
              </p>

              <p>
                Мелкооптовые партии реализуются с собственных и арендуемых
                региональных нефтебаз, а также Линейных
                производственно-диспетчерских станций (ЛПДС).
              </p>
              <h4>Непрерывный контроль качества</h4>
              <p>
                Все топливо соответствует ГОСТам и СТО, обеспечено сертификатами
                соответствия и паспортами качества заводов-производителей.
                Компания располагает как собственными стационарными
                аттестованными лабораториями контроля качества нефтепродуктов,
                так и мобильными автолабораториями. С помощью специально
                оборудованных автомобилей, буквально, в полевых условиях может
                быть проведен полный анализ проб нефтепродуктов за короткий
                промежуток времени.
              </p>
            </div>
          </div>
        </div>
        <div class="ViewDieselInfo__col">
          <div class="ViewDieselInfo__advantages-wrapper">
            <ul class="ViewPromo__advantages">
              <li class="ViewPromo__advantage">
                <div class="ViewPromo__advantage-icon">
                  <app-svg-icon
                    name="iphone"
                    class="ViewPromo__advantage-icon-svg"
                  ></app-svg-icon>
                </div>
                <div class="ViewPromo__advantage-text">
                  <h4 class="ViewPromo__advantage-title">Данные поставщика</h4>
                  <p>
                    Телефон компании:<br />
                    <strong
                      ><a
                        href="tel:+79671511480"
                        class="ViewPromo__advantage-contact-link"
                        >+7 (967) 151-14-80</a
                      ></strong
                    >
                  </p>
                  <p>
                    Адрес электронной почты:<br />
                    <strong
                      ><a
                        href="mailto:delo@msk.tatneft.ru"
                        class="ViewPromo__advantage-contact-link"
                        >delo@msk.tatneft.ru</a
                      ></strong
                    >
                  </p>
                  <!-- <a
                      class="ViewPromo__advantage-link"
                      href="/static/uploads/docs/Cкачать_реквизиты_пром-ресурс.doc"
                      download="Реквизиты ПромРесурс.doc"
                      >Cкачать реквизиты ПромРесурс</a
                    > -->
                </div>
              </li>
              <!-- <li class="ViewPromo__advantage">
                  <div class="ViewPromo__advantage-icon">
                    <app-svg-icon
                      name="lock-pin"
                      class="ViewPromo__advantage-icon-svg"
                    ></app-svg-icon>
                  </div>
                  <div class="ViewPromo__advantage-text">
                    <h4 class="ViewPromo__advantage-title">Базисы отгрузки</h4>
                    <p>
                      ДТ Рузаевка; н/б Аэрофьюлз (Аэропорт г. Нижний
                      Новгород);<br />
                      Дельта Торг
                    </p>
                  </div>
                </li> -->
            </ul>
          </div>
        </div>
      </div>
    </div>

    <view-oil-scheme class="ViewPromo__section"></view-oil-scheme>
    <view-safe-advantages class="ViewPromo__section"></view-safe-advantages>
    <view-advantages class="ViewPromo__section"></view-advantages>
    <view-landing-buttons class="ViewPromo__section"></view-landing-buttons>
  </div>
</template>

<script>
export default {
  name: 'ViewPromo',
  inject: ['responsive'],
  components: {
    ViewPromoProducts: () =>
      import('@/pages/static/components/ViewPromoProducts.vue'),
    ViewSafeAdvantages: () =>
      import('@/pages/static/components/ViewSafeAdvantages'),
    ViewTop: () => import('@/pages/static/components/ViewTop'),
    ViewAdvantages: () => import('@/pages/static/components/ViewAdvantages'),
    ViewOilScheme: () => import('@/pages/static/components/ViewOilScheme'),
    ViewLandingButtons: () =>
      import('@/pages/static/components/ViewLandingButtons'),
    ViewHowCards: () => import('@/pages/static/components/ViewHowCards'),
    AppSvgIcon: () => import('@/components/common/AppSvgIcon'),
  },
  data: () => ({
    title: 'Топливо оптом онлайн от поставщика ООО «Татнефть-АЗС-Запад»',
    desc: 'на платформе OPEN OIL MARKET',
    id: 1246,
    productId: 1796,
    name: 'ООО «Татнефть-АЗС-Запад»',
    inn: '1644040195',
  }),
};
</script>

<style lang="scss" scoped>
.ViewPromo__logo-img {
  height: rem(90);
}
</style>
